import { combineReducers } from 'redux';

import loading from 'modules/global/reducers/generic.loading';
import type { OpenModalAction } from 'modules/invoices/types';
import { LOCATION_CHANGE } from 'modules/router/actionTypes';
import { createReducer } from 'utils/ReduxUtils';

import * as types from '../../actionTypes';

export interface InvoiceUIModalReducer {
  open: boolean;
  interventionId: string | null;
  loading: boolean;
  importing: boolean;
}

// Reducer for open state
const openReducer = createReducer(false, {
  [types.OPEN_INVOICE_MODAL]: () => true,
  [types.CLOSE_INVOICE_MODAL]: () => false,
  [types.IMPORT_INVOICE_SUCCESS]: () => false,
  [LOCATION_CHANGE]: () => false
});

// Reducer for interventionId state
const interventionIdReducer = createReducer(null, {
  [types.OPEN_INVOICE_MODAL]: (_state: string | null, action: OpenModalAction) => action.payload?.interventionId || null,
  [types.CLOSE_INVOICE_MODAL]: () => null,
  [types.IMPORT_INVOICE_SUCCESS]: () => null,
  [LOCATION_CHANGE]: () => null
});

export default combineReducers({
  open: openReducer,
  interventionId: interventionIdReducer,
  loading: loading(types.FETCH_INVOICE_REQUEST),
  importing: loading(types.IMPORT_INVOICE_REQUEST)
});
